<template lang="pug">
  #top-nav
    template(v-if="$breakpoint.isTouch")
      #site-logo
        icon(data="~@/assets/svg/logo.svg" width="56" height="56" :fill="false" color="#DF5F2C")
        h1 OpenLikes

      Search
      ProfileMenu

    template(v-else)
      #site-logo
        icon(data="~@/assets/svg/logo.svg" width="56" height="56" :fill="false" color="#DF5F2C")
        h1 OpenLikes

      Search

      //- #nav-links
      RouterLink.nav-links(:to="{name: 'likesIndex'}") Likes
      RouterLink.nav-links(:to="{name: 'peopleIndex'}") People
      RouterLink.nav-links(:to="{name: 'visitorsIndex'}") Visitors

      ProfileMenu
</template>

<script>
export default {
  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  methods: {},

  components: {
    ProfileMenu: require('@/components/ProfileMenu').default,
    Search: require('@/components/Search').default,
  },
}

/* Computed ---------------------------------------------------- */
/* Watch ------------------------------------------------------- */
/* Methods ----------------------------------------------------- */
</script>
